interface GraziaMarkProps {
  className?: string;
  title?: string;
}

/**
 * Grazia's monogram: a lowercase "g" in rose gold on ink, with a spark.
 *
 * Drawn as paths (the "g" is Playfair Display's, the display serif) rather
 * than set in the font, so it renders the same in the favicon, where no web
 * font is available.
 */
export default function GraziaMark({ className, title }: GraziaMarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <rect width="32" height="32" rx="9" fill="#1E1A1B" />
      <path
        d="M13.6 25.46Q12.14 25.46 10.91 25.18Q9.67 24.89 8.93 24.31Q8.19 23.72 8.19 22.81Q8.19 21.95 8.92 21.3Q9.64 20.65 10.97 20.32L11.15 20.73Q10.61 20.97 10.31 21.49Q10.01 22.01 10.01 22.63Q10.01 23.77 11.07 24.4Q12.14 25.02 13.88 25.02Q15.05 25.02 16.11 24.72Q17.16 24.42 17.82 23.75Q18.48 23.07 18.48 22.01Q18.48 21.17 17.89 20.62Q17.29 20.06 15.52 20.06L13.7 20.06Q12.79 20.06 12.01 19.9Q11.23 19.74 10.75 19.29Q10.27 18.83 10.27 18Q10.27 17.07 11.05 16.23Q11.83 15.4 13.67 14.6L13.99 14.83Q13.23 15.25 12.65 15.68Q12.06 16.1 12.06 16.73Q12.06 17.56 13.26 17.56L16.35 17.56Q17.57 17.56 18.56 17.89Q19.55 18.21 20.15 18.91Q20.75 19.61 20.75 20.76Q20.75 21.98 19.95 23.06Q19.16 24.14 17.57 24.8Q15.99 25.46 13.6 25.46ZM13.75 15.04Q12.43 15.04 11.33 14.61Q10.24 14.18 9.62 13.27Q8.99 12.36 8.99 10.93Q8.99 9.5 9.62 8.58Q10.24 7.65 11.33 7.23Q12.43 6.8 13.75 6.8Q15.13 6.8 16.2 7.23Q17.26 7.65 17.89 8.58Q18.51 9.5 18.51 10.93Q18.51 12.36 17.89 13.27Q17.26 14.18 16.2 14.61Q15.13 15.04 13.75 15.04ZM13.75 14.57Q14.66 14.57 15.16 13.79Q15.65 13.01 15.65 10.93Q15.65 8.85 15.16 8.06Q14.66 7.26 13.75 7.26Q12.89 7.26 12.37 8.06Q11.85 8.85 11.85 10.93Q11.85 13.01 12.37 13.79Q12.89 14.57 13.75 14.57ZM17.6 8.98L17.13 8.8Q17.5 7.89 18.38 7.21Q19.26 6.54 20.23 6.54Q20.95 6.54 21.38 6.94Q21.81 7.34 21.81 8.07Q21.81 8.88 21.38 9.21Q20.95 9.55 20.49 9.55Q20.07 9.55 19.72 9.27Q19.37 8.98 19.32 8.37Q19.26 7.76 19.71 6.8L19.99 6.9Q18.95 7.32 18.47 7.77Q17.99 8.23 17.6 8.98Z"
        fill="#C49A8A"
      />
      <path
        d="M25.2 3.72C25.37 5.47 25.58 6.34 27 6.6C25.58 6.86 25.37 7.73 25.2 9.48C25.03 7.73 24.82 6.86 23.4 6.6C24.82 6.34 25.03 5.47 25.2 3.72Z"
        fill="#F4E9E4"
      />
    </svg>
  );
}
